import { memo } from "react";

interface Props {
  text?: string;
}

const LoadingState = memo(({ text = "Chargement..." }: Props) => (
  <div className="flex flex-col items-center justify-center h-40 gap-3 text-slate-400 col-span-full">
    <div className="h-9 w-9 rounded-full border-[3px] border-blue-100 border-t-blue-500 animate-spin" />
    <span className="text-sm font-medium">{text}</span>
  </div>
));

export default LoadingState;